import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
const {getUrl} = Util;
import cx from "classnames";
import Pic from "@/assets/images/academy/pic_1.8c66ec1e.png";
import Pic2 from "@/assets/images/academy/pic_2.523097f2.png";
import Picm2 from "@/assets/images/academy/picm2.png";
import Picm3 from "@/assets/images/academy/picm3.png";
import Download from "@/assets/images/academy/downmload.png";
import Download2 from "@/assets/images/academy/download2.png";
import Download3 from "@/assets/images/academy/download3.png";
import Download3s from "@/assets/images/academy/download3s.png";
import Downloadbig from "@/assets/images/academy/downloadbig.png";
import Downloadbighover from "@/assets/images/academy/downloadbighover.png";

import Pic3 from "@/assets/images/academy/pic2.png";
import Pic4 from "@/assets/images/academy/pic4.png";

import Eth1 from "@/assets/images/academy/ethereum.c1129ca6.png";
import Eth2 from "@/assets/images/academy/eth2.png";
import Eth3 from "@/assets/images/academy/eth3.png";
import Eth4 from "@/assets/images/academy/eth4.png";
import Bgdex from "@/assets/images/academy/pic_blockchain.054b20ca.png";
import Play from "@/assets/images/academy/play.png";
import Playvideo from "@/assets/images/academy/video.5a190815.png";
import Playvideos from "@/assets/images/academy/playms2.png";
import Playvideom from "@/assets/images/academy/videom.png";
import Cardbg from "@/assets/images/academy/cardbg.png";
import Cardbghover from "@/assets/images/academy/cardbghover.png";
import Cards from "@/assets/images/academy/cards.png";

import Nft1 from "@/assets/images/academy/nft1.png";
import Nft2 from "@/assets/images/academy/nft2.png";
import Nft3 from "@/assets/images/academy/nft3.png";
import Nft4 from "@/assets/images/academy/nft4.png";
import Nft5 from "@/assets/images/academy/nft5.png";
// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.content, className)}>
      <div className={cx(styles.currency, className)}>
        <div className={cx(styles.top, className)}>
          <div className={cx(styles.topLeft, className)}>
            <a href={getUrl("/academy/learn-crypto#academy0")}>
              <img src={Pic} />
              <h2>what is Cryptocurrency</h2>
            </a>
          </div>
          <div className={cx(styles.card, className)}>
            <img src={isMobile ? Picm2 : Pic2} />
            <div className={cx(styles.cardcontent, className)}>
              <div className={cx(styles.cardcontents, className)}>
                <h2>So what's the difference with normal currency?</h2>
                <h5>
                  Many of you might be wondering, what's wrong with the USD, or the Euro? What can Cryptocurrency do that the cash in my wallet can't do? These
                  are very valid questions and being able to distinguish the difference will help you better appreciate why cryptocurrencies have been gaining
                  such popularity.
                </h5>
              </div>
              <div className={cx(styles.cardlearn, className)}>
                <a href={getUrl("/academy/learn-crypto#academy1")}>
                  <p>Learn more</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.bottom, className)}>
          <div className={cx(styles.card, className)}>
            <img src={isMobile ? Picm3 : Pic3} />
            <div className={cx(styles.cardcontent, className)}>
              <div className={cx(styles.cardcontents, className)}>
                <h2>We can't talk about Cryptocurrency without talking about Bitcoin</h2>
                <h5>
                  When you hear about cryptocurrency, the first thing that will probably come to your mind is Bitcoin. Bitcoin has been a trailblazer in the
                  crypto world. Turning crypto from a mere concept, into a mainstream investment option.
                </h5>
              </div>
              <div className={cx(styles.cardlearn, className)}>
                <a href={getUrl("/academy/learn-crypto#academy2")}>
                  <p>Learn more</p>
                </a>
              </div>
            </div>
          </div>
          <div className={cx(styles.btmright, className)}>
            <img src={Pic4} />
            <div className={cx(styles.rightcontent, className)}>
              <h2>What is this Blockchain Technology I keep hearing about?</h2>
              <div className={cx(styles.learns, className)}>
                <a href={getUrl("/academy/learn-crypto#academy3")}>
                  <p>Learn more</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cx(styles.ethereum, className)}>
        <div className={cx(styles.top, className)}>
          <h2>Ethereum</h2>
          <a href={getUrl("/academy/learn-ethereum")}>
            <div className={cx(styles.ethereumcontent, className)}>
              <p>View All</p>
              <img src={Download2} />
            </div>
          </a>
        </div>
        <div className={cx(styles.bottom, className)}>
          <ul>
            <a href={getUrl("/academy/learn-ethereum")}>
              <li className={cx(styles.bottomfirst, className)}>
                <img src={Eth1} />
                <h4>What is Ethereum?</h4>
              </li>
            </a>
            <li>
              <a href={getUrl("/academy/learn-ethereum#ethereum2")}>
                <div className={cx(styles.card, className)}>
                  <img src={Eth2} />
                  <h4>So what's the difference - Ethereum vs. Bitcoin?</h4>
                  <img className={cx(styles.icon2, className)} src={Download3s} />
                  <div className={cx(styles.icon, className)} style={{ backgroundImage: `url(${Download3})` }}></div>
                </div>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-ethereum#ethereum3")}>
                <div className={cx(styles.card, className)}>
                  <img src={Eth3} />
                  <h4>What is Ether (ETH) and how is it different from Ethereum?</h4>
                  <img className={cx(styles.icon2, className)} src={Download3s} />
                  <div className={cx(styles.icon, className)} style={{ backgroundImage: `url(${Download3})` }}></div>
                </div>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-ethereum#ethereum4")}>
                <div className={cx(styles.card, className)}>
                  <img src={Eth4} />
                  <h4>what is Cryptography?</h4>
                  <img className={cx(styles.icon2, className)} src={Download3s} />
                  <div className={cx(styles.icon, className)} style={{ backgroundImage: `url(${Download3})` }}></div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={cx(styles.ido, className)}>
        <img src={isMobile ? Playvideos : Bgdex} />
        <div className={cx(styles.idocontent, className)}>
          <h2>Initial DEX Offering (IDO)</h2>
          <h5>If there is a crypto related project in need of capital, one of the methods to obtain it is through Initial DEX Offering, or IDO.</h5>
          <div className={cx(styles.learn, className)}>
            <a href={getUrl("/academy/learn-ido")}>
              <p>Learn more</p>
            </a>
          </div>
        </div>
      </div>
      <div className={cx(styles.metaverse, className)}>
        <div className={cx(styles.top, className)}>
          <div className={cx(styles.topLeft, className)}>
            <h2>The Metaverse</h2>
            { !isMobile ?<p>
              In simple terms, the Metaverse is a hyper realistic, digital universe which is underpinned by the use of augmented reality (AR) and virtual
              reality (VR) technology.The Metaverse is a place which combines the digital, with the physical, to create a new medium where interconnectivity and
              interactivity are key. In many ways, we are already on our way to transitioning into the Metaverse. Video games are a good representation of a
              more immersive version of the internet, where our virtual character (also known as an avatar), interacts with other players from all over the
              world at the same time. This concept of an immersive, real-time version of the internet is one of the distinguishing features of the Metaverse.
            </p> :
            <p>In simple terms, the Metaverse is a hyper realistic, digital universe which is underpinned by the use of augmented reality (AR) and virtual reality (VR) technology. </p>}
            <div>
              <a href={getUrl("/academy/learn-metaverse")}>
                <p>Learn more</p>
                {isMobile ? ">>" : <img src={Download2} />}
              </a>
            </div>
          </div>
          <div className={cx(styles.topRight, className)} style={{ backgroundImage: `url(${Playvideo})` }}>
            <a href="https://www.youtube.com/watch?v=ILOo2K7TNAw" target="_blank">
              <div className={cx(styles.play, className)} style={{ backgroundImage: `url(${isMobile ? Playvideom : Play})` }}></div>
            </a>
          </div>
        </div>
        <div className={cx(styles.bottom, className)}>
          <div className={cx(styles.leftcard, className)} style={{ backgroundImage: `url(${isMobile ? Cards : Cardbg})` }}>
            <div className={cx(styles.cardleft, className)}>
              <h3>So what exactly is the difference with the internet we use today?</h3>
            </div>
            <div className={cx(styles.cardright, className)}>
              <a href={getUrl("/academy/learn-metaverse#metaverse1")}>
                <div className={cx(styles.imgs, className)} style={{ backgroundImage: `url(${Downloadbig})` }}></div>
              </a>
            </div>
          </div>
          <div className={cx(styles.rightcard, className)} style={{ backgroundImage: `url(${isMobile ? Cards : Cardbg})` }}>
            <div className={cx(styles.cardleft, className)}>
              <h3>So what can you do in the Metaverse?</h3>
            </div>
            <div className={cx(styles.cardright, className)}>
              <a href={getUrl("/academy/learn-metaverse#metaverse2")}>
                <div className={cx(styles.imgs, className)} style={{ backgroundImage: `url(${Downloadbig})` }}></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={cx(styles.nft, className)}>
        <div className={cx(styles.top, className)}>
          <h2>NFT’s</h2>
        </div>
        <div className={cx(styles.content, className)}>
          <div className={cx(styles.wrapper, className)}>
            <div className={cx(styles.cards, className)}>
              <a href={getUrl("/academy/learn-nft-1")}>
                <img src={Nft1} />
                <div className={cx(styles.cardbottom, className)}>
                  <h4>Non-Fungible Tokens (NFT's)</h4>
                  <p>
                    Not to be misunderstood as a “Non-fundible token ”, a Non-fungible token, or NFT's for short, is yet another feature supported by blockchain
                    technology.{" "}
                  </p>
                </div>
                <div className={cx(styles.cardmore, className)}>
                  <h5>Learn more</h5>
                  <div className={cx(styles.cardmoreimg, className)}></div>
                  <img src={Downloadbig} className={cx(styles.down1, className)} />
                  <img className={cx(styles.down2, className)} src={Downloadbighover} />
                </div>
              </a>
            </div>
          </div>
          <div className={cx(styles.wrapper, className)}>
            <div className={cx(styles.cards, className)}>
              <a href={getUrl("/academy/learn-nft-2")}>
                <img src={Nft2} />
                <div className={cx(styles.cardbottom, className)}>
                  <h4>So what can I do with an NFT?</h4>
                  <p>Great question, imagine playing a video game where you play against other players from around the world.</p>
                </div>
                <div className={cx(styles.cardmore, className)}>
                  <h5>Learn more</h5>
                  <div className={cx(styles.cardmoreimg, className)}></div>
                  <img src={Downloadbig} className={cx(styles.down1, className)} />
                  <img className={cx(styles.down2, className)} src={Downloadbighover} />
                </div>
              </a>
            </div>
          </div>
          <div className={cx(styles.wrapper, className)}>
            <div className={cx(styles.cards, className)}>
              <a href={getUrl("/academy/learn-nft-3")}>
                <img src={Nft3} />
                <div className={cx(styles.cardbottom, className)}>
                  <h4>What's to stop me from taking a screenshot of someone else's NFT?</h4>
                  <p>Yes, it is true. Technically you could do this.</p>
                </div>
                <div className={cx(styles.cardmore, className)}>
                  <h5>Learn more</h5>
                  <div className={cx(styles.cardmoreimg, className)}></div>
                  <img src={Downloadbig} className={cx(styles.down1, className)} />
                  <img className={cx(styles.down2, className)} src={Downloadbighover} />
                </div>
              </a>
            </div>
          </div>
          <div className={cx(styles.wrapper, className)}>
            <div className={cx(styles.cards, className)}>
              <a href={getUrl("/academy/learn-nft-4")}>
                <img src={Nft4} />
                <div className={cx(styles.cardbottom, className)}>
                  <h4>So what's a blue chip NFT?</h4>
                  <p>In simple terms, an NFT that is referred to as a blue chip NFT is one that is expected to be a long term good investment.</p>
                </div>
                <div className={cx(styles.cardmore, className)}>
                  <h5>Learn more</h5>
                  <div className={cx(styles.cardmoreimg, className)}></div>
                  <img src={Downloadbig} className={cx(styles.down1, className)} />
                  <img className={cx(styles.down2, className)} src={Downloadbighover} />
                </div>
              </a>
            </div>
          </div>
          <div className={cx(styles.wrapper, className)}>
            <div className={cx(styles.cards, className)}>
              <a href={getUrl("/academy/learn-nft-5")}>
                <img src={Nft5} />
                <div className={cx(styles.cardbottom, className)}>
                  <h4>What to expect from NTF's in the future</h4>
                  <p>With a flourishing Metaverse, the future of NFT's is bright.</p>
                </div>
                <div className={cx(styles.cardmore, className)}>
                  <h5>Learn more</h5>
                  <div className={cx(styles.cardmoreimg, className)}></div>
                  <img src={Downloadbig} className={cx(styles.down1, className)} />
                  <img className={cx(styles.down2, className)} src={Downloadbighover} />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
